module.exports = __webpack_public_path__ + "media/images/pepsi_home/digin-logo-2197a26312c9f3fdb8436d9bf74189c4.svg";